import type { TrainingProgress, EnrichedTrainingProgress } from '@/hooks/use-training-progress';

import { CircularProgress } from '@/features/training/components/circular-progress';
import { formatMinutes, formatPercentage } from '@/lib/format';

interface ProgressOverviewProps {
  progress: TrainingProgress | EnrichedTrainingProgress;
}

export function ProgressOverview({ progress }: ProgressOverviewProps) {
  const allDone = progress.completed_modules === progress.total_modules;

  return (
    <div className="flex flex-col items-center gap-6 rounded-lg border bg-card p-8 text-center">
      {allDone && (
        <div className="rounded-full bg-green-100 px-4 py-1 text-sm font-medium text-green-800">
          Congratulations! All modules complete.
        </div>
      )}
      <CircularProgress
        value={progress.completed_modules}
        max={progress.total_modules}
        size={160}
        strokeWidth={12}
      >
        <span className="text-4xl font-bold">
          {formatPercentage(progress.completion_percentage)}
        </span>
        <span className="text-sm text-muted-foreground">complete</span>
      </CircularProgress>
      <div className="flex gap-8 text-center">
        <div>
          <p className="text-2xl font-bold">
            {progress.completed_modules}/{progress.total_modules}
          </p>
          <p className="text-sm text-muted-foreground">Modules</p>
        </div>
        <div>
          <p className="text-2xl font-bold">{formatMinutes(progress.completed_minutes)}</p>
          <p className="text-sm text-muted-foreground">Time Invested</p>
        </div>
      </div>
    </div>
  );
}
